import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  mission: null,
};

export const missionSlice = createSlice({
  name: 'mission',
  initialState,
  reducers: {
    setMission: (state, action) => {
      state.mission = action.payload;
    },

    clearMission: (state) => {
      state.mission = null;
    },
  },
});

export const { setMission, clearMission } = missionSlice.actions;
export const selectMission = (state) => state.mission.mission;
export default missionSlice.reducer;
